import { AbstractControl, ValidationErrors } from '@angular/forms';

export function codiceAtecoValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim();

  return !value || /^\d{1,2}\.\d{1,2}\.\d{1,2}$/.test(value)
    ? null
    : { codiceAteco: true };
}
